// DiceBear Bottts avatars — shared across all packs
import avatar1 from './bottts-1767950088845.svg';
import avatar2 from './bottts-1767950096516.svg';
import avatar3 from './bottts-1767950099472.svg';
import avatar4 from './bottts-1767950103990.svg';
import avatar5 from './bottts-1767950107444.svg';
import avatar6 from './bottts-1767950111031.svg';
import avatar7 from './bottts-1767950117084.svg';
import avatar8 from './bottts-1767950119631.svg';
import avatar9 from './bottts-1767950122808.svg';
import avatar10 from './bottts-1767950125358.svg';
import avatar11 from './bottts-1767950127896.svg';
import avatar12 from './bottts-1767950142838.svg';

export const avatars = [
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  avatar10,
  avatar11,
  avatar12,
];

// Helper to get avatar by index (wraps around)
export const getAvatarByIndex = (index: number) => {
  return avatars[index % avatars.length];
};

// Helper to get a random avatar
export const getRandomAvatar = () => {
  return avatars[Math.floor(Math.random() * avatars.length)];
};
